function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 48,
  height: 48,
  rx: 24,
  fill: "#E1492A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.7892 21.7502C35.9401 22.5532 36.0205 23.3931 36.0205 24.2699C36.0205 31.1249 31.4304 36 24.5 36C17.8697 36 12.5 30.6303 12.5 24C12.5 17.3697 17.8697 12 24.5 12C27.7406 12 30.448 13.192 32.5251 15.1282L29.1421 18.5113V18.5029C27.8831 17.3026 26.2854 16.6873 24.5 16.6873C20.5402 16.6873 17.3231 20.0319 17.3231 23.9933C17.3231 27.9531 20.5402 31.3059 24.5 31.3059C28.0926 31.3059 30.5369 29.2506 31.0415 26.4308H24.5V21.7502H35.7892Z",
  fill: "white"
});

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.0e42ef5e.svg";
export { ForwardRef as ReactComponent };